import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "target-with-variants" }
const _hoisted_2 = { class: "header-row" }
const _hoisted_3 = { class: "time-stamp-wrapper" }
const _hoisted_4 = { class: "time-stamp" }
const _hoisted_5 = { class: "close-icon" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TranslationVariants = _resolveComponent("TranslationVariants")!
  const _component_el_popover = _resolveComponent("el-popover")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_popover, {
      visible: _ctx.focused && _ctx.variantsPopupVisible,
      placement: "bottom",
      "show-arrow": false,
      width: 1160,
      "popper-class": "variants-popover"
    }, {
      reference: _withCtx(() => [...(_cache[3] || (_cache[3] = [
        _createElementVNode("span", null, null, -1)
      ]))]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "popover-name" }, [
            _createElementVNode("div", null, " Translation variants ")
          ], -1)),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.variantsTimestamp), 1),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("span", {
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeVariantsPopup && _ctx.closeVariantsPopup(...args))),
                class: "material-symbols-outlined"
              }, " close ")
            ])
          ])
        ]),
        (_ctx.variantsPopupVisible && _ctx.focused)
          ? (_openBlock(), _createBlock(_component_TranslationVariants, {
              key: 0,
              modelValue: _ctx.segmentItem,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.segmentItem) = $event)),
              configuration: _ctx.configuration,
              loading: _ctx.segmentLoading
            }, null, 8, ["modelValue", "configuration", "loading"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}